module.exports = __webpack_public_path__ + "img/r0-ur3.79e3789e.jpg";